import { APP_LINK_DOMAIN, ONELINK_HOST } from 'src/config/externalLinks';

const ALLOWED_PARAMS = new Set([
  'accessory',
  'activeChildUserId',
  'addContent',
  'angle',
  'animal',
  'chapterId',
  'chapterUuid',
  'childId',
  'createdFromParent',
  'debug',
  'deviceType',
  'email',
  'emotion',
  'existing',
  'family_code',
  'fbclid',
  'forceWebRouter',
  'frequency',
  'from',
  'fromParentOnboarding',
  'gad_source',
  'gclid',
  'gender',
  'generation',
  'join_code',
  'lessonId',
  'mode',
  'msclkid',
  'onboardingCode',
  'oobCode',
  'ref',
  'referral_code',
  'schoolGroup',
  'screen',
  'scrollToLessonId',
  'selectedParentIds',
  'session_id',
  'shortTrial',
  'source',
  'stack',
  'subject',
  'tab',
  'targetChildUserId',
  'to',
  'token',
  'ttclid',
  'user_type',
]);

const ALLOWED_PARAM_PREFIXES = ['utm_'];

const isAllowedParam = (key: string): boolean =>
  ALLOWED_PARAMS.has(key) ||
  ALLOWED_PARAM_PREFIXES.some(prefix => key.startsWith(prefix));

const parseWebUrl = (value: string): URL | null => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url : null;
  } catch {
    return null;
  }
};

const isSameOrSubdomain = (hostname: string, domain: string): boolean =>
  hostname === domain || hostname.endsWith(`.${domain}`);

const resolveOnelinkTarget = (url: URL): string | null => {
  const deepLinkValue = url.searchParams.get('deep_link_value');
  if (!deepLinkValue) return null;
  try {
    return decodeURIComponent(deepLinkValue);
  } catch {
    return null;
  }
};

export const resolveDeepLink = (
  value: string,
  currentSearch: string,
): string | null => {
  let url = parseWebUrl(value);
  if (url && isSameOrSubdomain(url.hostname, ONELINK_HOST)) {
    const target = resolveOnelinkTarget(url);
    url = target ? parseWebUrl(target) : null;
  }
  if (!url || !url.hostname.endsWith(APP_LINK_DOMAIN)) return null;

  const params = new URLSearchParams(currentSearch);
  url.searchParams.forEach((paramValue, key) => {
    if (isAllowedParam(key)) params.set(key, paramValue);
  });
  const search = params.toString();
  return search ? `${url.pathname}?${search}` : url.pathname;
};
